
import { mapGetters, mapMutations, mapActions } from 'vuex'
import ColorSwatch from './color-swatch.vue'
export default {
  components: {
    ColorSwatch,
  },
  props: {
    facetData: {
      type: Object,
      default: () => ({}),
    },
    filterData: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    selectedColor: '',
    isFocused: false,
  }),
  computed: {
    ...mapGetters({
      vxSearchFilters: 'search/getSearchFilters',
      vxStoryContent: 'search/getStoryContent',
    }),
    filterValue() {
      return `filter.${this.facetData.field}=${this.filterData.value}`
    },
    searchFilters: {
      get() {
        return this.vxSearchFilters
      },
      set(value) {
        this.vxSetSearchFilters(value)
        this.vxQuerySearchspring()
      },
    },
    isSelected() {
      return this.vxSearchFilters.includes(this.filterValue)
    },
  },
  methods: {
    ...mapMutations({
      vxSetSearchFilters: 'search/setSearchFilters',
    }),
    ...mapActions({
      vxQuerySearchspring: 'search/querySearchspring',
    }),
    isOverrided(color) {
      const override = this.vxStoryContent.puce_colors.find((x) => {
        return x.color_name === color
      })
      return override ? override.color : color
    },
  },
}
